export default __webpack_public_path__ + "static/media/Inclusion-Black.d09dd658.svg";